module.exports = __webpack_public_path__ + "img/checkmark-red.b0c0c3ed.svg";